export enum ProviderStatusEnum {
    Active = 1,
    Inactive = 2,
    Suspended = 3,
}
